module.exports = __webpack_public_path__ + "images/gow_rgba(0,0,0,0.7).9a6210c02e3ebf42b0fd767bf4ea2e6b.jpg";